import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'
import { OptionCard } from '../components'
import useKeyboardNavigation from '../../../hooks/useKeyboardNavigation'

const LearningPreferencesPage = ({
  preferences,
  selectedPreferences,
  onTogglePreference
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const { focusedIndex, handleKeyDown } = useKeyboardNavigation(
    preferences.length,
    isMobile ? 1 : 2,
    (index) => onTogglePreference(preferences[index].text)
  )

  return (
    <Box className={classes.content} data-test='learning-preferences-page' onKeyDown={handleKeyDown}>
      <Typography
        id='lpq-dialog-title'
        className={classes.question}
        data-test='learning-preferences-title'
        component='h2'
      >
        How do you prefer to learn?
      </Typography>
      <Typography
        id='lpq-dialog-description'
        className={classes.subtitle}
        data-test='learning-preferences-subtitle'
      >
        Select all that apply so we can recommend the best content format for
        you.
      </Typography>
      <Box
        className={classes.optionsGrid}
        data-test='learning-preferences-grid'
        role='group'
        aria-label='Learning preference options'
      >
        {preferences.map((preference, index) => {
          const IconComponent = preference.icon
          const isSelected = selectedPreferences.includes(preference.text)

          return (
            <OptionCard
              key={preference.text}
              text={preference.text}
              isSelected={isSelected}
              onClick={() => onTogglePreference(preference.text)}
              icon={IconComponent}
              variant='default'
              isFocused={focusedIndex === index}
              onKeyDown={handleKeyDown}
            />
          )
        })}
      </Box>
    </Box>
  )
}

export default LearningPreferencesPage
